import { configuration } from '../configuration';
import { IModule, ISection } from '../configurationTypes';

const availableModules: string[] = configuration.modules.reduce((all: string[], m: IModule) => {
    if (m.enable) {
        if ('sections' in m) {
            const allOff = (m.sections || []).every((section: ISection) => section.enable === false)
            if (allOff) {
                return all
            } 
            const sections: string[] = (m.sections || []).reduce((allSections: string[], s: ISection) => {
                if (s.enable) {
                    return [...allSections, `${m.module}/${s.section}`]
                }
                return allSections
            }, [])
            return [...all, m.module, ...sections]
        } else {
            return [...all, m.module]
        }
    } else {
        return all
    }
}, [])

export const permissionsCode: { [key: string]: string } = {...configuration.permissions, ...configuration.modules.reduce((all: object, m: IModule) => {
    if (m.enable) {
        const sectionPermissions = (m.sections || []).reduce((all: object, s: ISection)=>{
            if (s.enable) return {...all, ...(s.permissions || {})}
            return all
        },{})
        return {...all, ...(m.permissions || {}), ...sectionPermissions}
    }
    return all
}, {})}


export const checkModule = (module: string | undefined | null) => {
    if (!module) return false
    return availableModules.includes(module)
}